/*
	Overwatch (non-mobile) main menu functionality.
*/
(function(window, overwatch){

    var MainMenu = function() {

    	function init(options) {
    		var $window = $(window);

    		// Menus
    		var $menuMainWrap = options.$menuMainWrap;
    		var $menuMain = options.$menuMain;
    		var $socialMenuMain = options.$socialMenuMain;

    		// Menu pin
    		var $menuMainPin = options.$menuMainPin;

    		// Buy button
    		var $buyButtonWrap = options.$buyButtonWrap;

    		// Other options
    		var hiddenClass = options.hiddenClass;
    		var fixedClass = options.fixedClass;
    		var menuMainThreshold = options.menuMainThreshold;
    		var previousScrollTop = 0;

    		// Scroll functionality for main menu.
    		$window.on("scroll", function() {
    			var scrollTop = $window.scrollTop();
    			// need to do this check since ie11 in windows 8.1 fires scroll event more than once
    			if (scrollTop !== previousScrollTop) {
    				// Hide menu if scroll pos is greater than threshold.
    				var hideMenu = scrollTop > menuMainThreshold;

    				// Hide menu if scrolled down.
    				hideMenu = hideMenu && scrollTop > previousScrollTop;

    				$menuMainWrap.toggleClass(hiddenClass, hideMenu);
    				previousScrollTop = scrollTop;
    			}

    			$menuMain.toggleClass(fixedClass, scrollTop > 44);
    			$socialMenuMain.toggleClass(fixedClass, scrollTop > 44);

    			updateBuyButton(scrollTop);
    		});

    		$menuMainPin.on("mouseenter", function() {
    			$menuMainWrap.removeClass(hiddenClass);
    		});

    		function updateBuyButton(scrollTop) {
    			$buyButtonWrap.toggleClass(fixedClass, scrollTop > 44);
    		}
    		
    	}

    	return {
    		init: init
    	};

    };

    window.MainMenu = MainMenu();

}(window, window.overwatch));
